import React from 'react';
import { Link } from 'react-router-dom';

export function OptionCard({ icon, title, description, link, onClick, inProgress, scenarioCount }) {
  const cardContent = (
    <>
      {inProgress && (
        <div className="card-badges">
          <span className="wip-badge">In Progress</span>
          {scenarioCount !== undefined && (
            <span className="count-badge">Scenarios: {scenarioCount}</span>
          )}
        </div>
      )}
      <div className="option-icon">
        {icon}
      </div>
      <div className="option-content">
        <h3 className="option-title">{title}</h3>
        <p className="option-description">{description}</p>
      </div>
    </>
  );

  if (onClick) {
    return (
      <div className="option-card" onClick={onClick}>
        {cardContent}
      </div>
    );
  }

  if (link) {
    return (
      <Link to={link} className="option-card">
        {cardContent}
      </Link>
    );
  }

  return (
    <div className="option-card">
      {cardContent}
    </div>
  );
} 